import React from "react";
import { Row, Col } from "react-bootstrap";

import Setting from "./Setting";

import BudgetOrderingSetting from "./settings/BudgetOrderingSetting";
import HomepageSetting from "./settings/HomepageSetting";
import ThemeSetting from "./settings/ThemeSetting";
import NegativeAmountDisplaySetting from "./settings/NegativeAmountDisplaySetting";
import MultipleCurrenciesEnabledSetting from "./settings/MultipleCurrenciesEnabledSetting";

import AuthorizeService from "./api-authorization/AuthorizeService";

export default class Settings extends React.Component
{
	constructor(props)
	{
		super(props);
		this.state = {loading: true, isPremiumUser: false};
	}

	componentDidMount()
	{
		this.makeRemoteRequest();
	}

	async makeRemoteRequest()
	{
		const isPremiumUser = await AuthorizeService.isPremiumUser();
		this.setState({loading: false, isPremiumUser});
	}

	render()
	{
		const labelSize = 3;
		const {loading, isPremiumUser} = this.state;

		if (loading)
		{
			return <div />;
		}

		return (
			<Row>
				<Col xs={10} xsOffset={1}>
					<Setting
						label="Homepage:"
						labelSize={labelSize}
						isPremiumFeature={true}
						isPremiumUser={isPremiumUser}
					>
						<HomepageSetting/>
					</Setting>
					<Setting
						label="Theme:"
						labelSize={labelSize}
						isPremiumFeature={true}
						isPremiumUser={isPremiumUser}
					>
						<ThemeSetting/>
					</Setting>
					<Setting
						label="Negative Amount Display:"
						labelSize={labelSize}
						isPremiumFeature={true}
						isPremiumUser={isPremiumUser}
					>
						<NegativeAmountDisplaySetting/>
					</Setting>
					<Setting
						label="Budget Ordering:"
						labelSize={labelSize}
						isPremiumFeature={true}
						isPremiumUser={isPremiumUser}
					>
						<BudgetOrderingSetting/>
					</Setting>
					<Setting
						label="Use Multiple Currencies:"
						labelSize={labelSize}
						isPremiumFeature={true}
						isPremiumUser={isPremiumUser}
					>
						<MultipleCurrenciesEnabledSetting/>
					</Setting>
				</Col>
			</Row>
		);
	}
}



// WEBPACK FOOTER //
// ./Components/components/Settings.jsx